import React, { useState, useEffect, useContext } from "react";
import ActionButton from "../Button/ActionButton";
import MultiBarChart from "../d3Charts/MultiBarChart/MultiBarChart";
import { MULTI_BAR_DATA } from "../SAMPLE_DATA";
import "./Summary.scss";
import GraphDownloadButton from "../Button/GraphDownloadButton/GraphDownloadButton";
import { colorArray } from "../../utils/theme";
import Loader from "../Loader/Loader";
import AxiosService from "../../utils/AxiosService";
import { AppContext } from "../../context/AppContext";
import { KEY_NAME } from "../../utils/KeyName";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import AboutChartToggle from "../AboutChartToggle/AboutChartToggle";
import SomethingWentWrong from "../SomethingWentWrong/SomethingWentWrong";

const Summary = React.memo(function ({ queryDataObj }) {
  const { get, set, setMultiple } = useCustomSearchParams();
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  const [chartData, setChartData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const axiosService = new AxiosService();
  const { entityName, selectedFilterBy, selectedFilterByLabel } =
    useContext(AppContext);

  useEffect(() => {
    if (!entityName) return;
    setIsLoading(true);
    setHasError(false);
    switch (entityName) {
      case KEY_NAME.FUNDER:
        axiosService
          .getFunderOkCounts(queryDataObj, shortName)
          // .getFunderOkCounts(publisherQuery, shortName)
          .then((response) => {
            setChartData(response.data);
          })
          .catch((error) => {
            console.error("Publisher Report Error:", error);
            setChartData(null);
            setHasError(true);
          })
          .finally(() => {
            setIsLoading(false);
          });

        break;
      case KEY_NAME.PUBLISHER:
      case KEY_NAME.INSTITUTION:
        axiosService
          .getPublisherOkCounts(queryDataObj, shortName)
          .then((response) => {
            setChartData(response.data);
          })
          .catch((error) => {
            console.error("Error:", error);
            setChartData(null);
            setHasError(true);
          })
          .finally(() => {
            setIsLoading(false);
          });

        break;
      // case KEY_NAME.INSTITUTION:
      //   axiosService
      //     .getPublisherOkCounts(queryDataObj, shortName)
      //     .then((response) => {
      //       setChartData(response.data);
      //     })
      //     .catch((error) => {
      //       console.error("Error:", error);
      //     })
      //     .finally(() => {
      //       setIsLoading(false);
      //     });
      //   break;

      default:
        break;
    }
    // }
  }, [entityName, queryDataObj]);

  return (
    <div className="summary-container mt-4 position-relative">
      {/* Top row */}
      <div className="summary-header">
        {/* <p className="text-secondary text-start">
          Graph represents key performance indicators to date for the
          publications reporting on funded research. Hover over colored bars to
          see additional values.
        </p> */}
      </div>

      {/* Chart */}
      {isLoading ? (
        <Loader />
      ) : hasError ? (
        <SomethingWentWrong />
      ) : (
        <div className="summary-chart ">
          <MultiBarChart
            chartData={chartData?.data}
            chartConfig={chartData?.config}
            chartType="percentage" //percentage or value
            keys={["countDetails"]}
            title={`${shortName}${selectedFilterBy !== "ALL" ? "__" + selectedFilterByLabel?.trim() : ""} Publications Tracked by CHORUS`}
            notes="Graph represents key performance indicators to date for the publications reporting on funded research. Hover over colored bars to   see additional values."
            colorArray={colorArray}
          />
        </div>
      )}
    </div>
  );
});

export default Summary;
